import useSWR from "swr";
import type { Fanpage, FanpageResponse } from "../../shared/types";

const fetcher = (url: string): Promise<Fanpage[]> =>
  fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json() as Promise<FanpageResponse>;
    })
    .then((json) => json.data);

/**
 * SWR hook to fetch fanpages from /api/fanpages.
 * Revalidates every 5 minutes, on focus, and on reconnect.
 */
export function useFanpages(): {
  data: Fanpage[] | undefined;
  isLoading: boolean;
  error: Error | undefined;
  mutate: () => void;
} {
  const { data, error, isLoading, mutate } = useSWR<Fanpage[], Error>(
    "/api/fanpages",
    fetcher,
    {
      refreshInterval: 5 * 60 * 1000, // 5 minutes
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      focusThrottleInterval: 60 * 1000, // 60 seconds
      dedupingInterval: 2000,
    }
  );

  return { data, isLoading, error, mutate };
}
